import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import NormalButton from 'components/atoms/Button/NormalButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { chatList } from 'modules/actions/chat';
import { sendComplaintSearch } from 'modules/actions/sendComplaintSearch';
import './style.scss';

const ComplaintSearch = () => {
  const complaintSearchResult = useSelector(state => state.complaintSearchResult);
  const dispatch = useDispatch();

  const searchId_ref = useRef();
  const call_ref = useRef();

  const [alertText, setAlertText] = useState('-');
  const [alertClass, setAlertClass] = useState('d-none');

  // useEffect(() => {
  //   if (searchId_ref.current) {
  //     searchId_ref.current.focus();
  //   }
  // }, []);

  useEffect(() => {
    if (complaintSearchResult.result === '200') {
      setAlertClass('d-none');
      setAlertText('조회가 성공하였습니다.');
    } else if (complaintSearchResult.result === '100') {
      setAlertClass('text-danger text-bold');
      setAlertText('조회에 실패하였습니다. 접수번호 및 연락처를 확인해주세요.');
    }
  }, [complaintSearchResult.result]);

  const onKeyPressEvt = e => {
    const invalidCharacters = ['-', '*', '.'];
    if (invalidCharacters.includes(e.key)) {
      e.preventDefault();
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      complaintSearch();
    }
  };

  const checkRegExp = (str, type = 'default') => {
    let isSafe = false;
    if (type === 'call') {
      const callReg = new RegExp(/[^0-9-]/gi);
      isSafe = !callReg.test(str);
    } else if (type === 'text') {
      const textReg = new RegExp(/[^0-9a-zA-Zㄱ-힣\s]/gi);
      isSafe = !textReg.test(str);
    } else {
      const defaultReg = new RegExp(/[^0-9a-zA-Zㄱ-힣-?!.,()@/~\s]/gi);
      isSafe = !defaultReg.test(str);
    }

    return isSafe;
  };

  const complaintSearch = e => {
    const isSearchId = searchId_ref.current.value !== '' && checkRegExp(searchId_ref.current.value, 'text');
    const isCall = call_ref.current.value !== '' && checkRegExp(call_ref.current.value, 'call');

    const callOnlyNumber = call_ref.current.value.replace(/-/g, '');
    const isCallLen = callOnlyNumber.length >= 8 && callOnlyNumber.length <= 11;

    setAlertClass('text-danger text-bold');
    if (!isSearchId) {
      setAlertText('※ 접수번호를 확인해 주세요.');
    } else if (!isCall) {
      setAlertText('※ 휴대폰번호 형식을 확인해 주세요.\n 예시) 01011112222');
    } else if (!isCallLen) {
      setAlertText('※ 휴대폰번호 자릿 수를 확인해 주세요.\n 예시) 01011112222');
    } else {
      setAlertClass('d-none');
      // const sign = window.confirm('민원 처리 결과를 조회하시겠습니까?');
      const sign = true;
      if (sign) {
        call_ref.current.value = callOnlyNumber;

        dispatch(
          sendComplaintSearch({
            searchId: searchId_ref.current?.value.trim(),
            call: callOnlyNumber,
            status: false,
          })
        );
      }
    }
  };

  const endComplaintSearch = (inStr, inLabel) => {
    const paramSet = {
      inType: ' query',
      inStr,
      inLabel,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
      responseHidden: 'Y',
    };
    dispatch(disableAllMenu());
    dispatch(sendComplaintSearch({ status: 'stop' }));
    dispatch(chatList(paramSet));
  };

  return (
    <div className="complaint_search_bg">
      <div
        className="_box"
        style={{
          height:
            complaintSearchResult.result === '200' ? '500px' : complaintSearchResult.result === '400' ? '410px' : alertClass === 'd-none' ? '330px' : '330px',
          transition: 'height 0.1s',
        }}
      >
        <div className="_top">
          <div className="_tit">민원접수 결과 조회</div>
          <div
            className="_close"
            onClick={() => endComplaintSearch('민원조회종료', '민원 결과 확인 종료')}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                endComplaintSearch('민원조회종료', '민원 결과 확인 종료');
              }
            }}
          >
            <IconButton
              icon="ri-close-line"
              styleDef={{ width: '15px', fontSize: '30px', fontWeight: 100, position: 'absolute', top: '19px', right: '20px', height: '15px' }}
              label="닫기 버튼"
              tabIndex="2"
            />
          </div>
        </div>
        <div className="_middle">
          <div
            className="_complaint_div"
            style={{
              height: complaintSearchResult.result === '200' ? '430px' : complaintSearchResult.result === '400' ? '160px' : '160px',
              overflowY: complaintSearchResult.result === '200' ? 'auto' : complaintSearchResult.result === '400' ? 'visible' : 'visible',
              padding: '0em 1.1em 0em 1.1em',
            }}
          >
            <div className="_input_div">
              <ul className="_item">
                <li className="_label">
                  <label htmlFor="_cont_searchId">
                    <span className="text-danger">* </span>접수번호
                  </label>
                </li>
                <li className="_cont">
                  <input
                    onInput={e => {
                      if (e.target.value.length > e.target.maxLength) {
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }
                    }}
                    ref={searchId_ref}
                    onKeyPress={onKeyPressEvt}
                    onKeyDown={e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                    onWheel={e => e.target.blur()}
                    id="_cont_searchId"
                    type="number"
                    placeholder="접수번호를 숫자로만 입력하세요."
                    autoComplete="off"
                    tabIndex={1}
                    inputMode="numeric"
                    pattern="[0-9]+"
                    maxLength={20}
                  />
                </li>
              </ul>
              <ul className="_item">
                <li className="_label">
                  <label htmlFor="_cont_call">
                    <span className="text-danger">* </span>휴대폰번호
                  </label>
                </li>
                <li className="_cont">
                  <input
                    onInput={e => {
                      if (e.target.value.length > e.target.maxLength) {
                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }
                    }}
                    ref={call_ref}
                    onKeyPress={onKeyPressEvt}
                    onKeyDown={e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                    onWheel={e => e.target.blur()}
                    id="_cont_call"
                    type="number"
                    placeholder="- 없이 숫자로만 입력하세요."
                    autoComplete="off"
                    tabIndex={1}
                    inputMode="numeric"
                    pattern="[0-9]+"
                    maxLength={11}
                  />
                </li>
              </ul>
              <div className="align-right">
                <span className="text-danger">* </span>은 필수 입력 항목입니다.
              </div>
              <div>
                <div id="divAlert" className={alertClass}>
                  {alertText}
                </div>
                <NormalButton
                  label="민원 결과 조회"
                  styleDef={{ color: '#FFF', background: '#BE314B', height: '3em', margin: '1em 0 1em 0', borderRadius: '5px' }}
                  clickEvt={complaintSearch}
                  tabIndex="1"
                />
              </div>
            </div>

            <div id="searchResult" className={complaintSearchResult.result === '200' || complaintSearchResult.result === '400' ? '_result_div' : 'd-none'}>
              {complaintSearchResult.result === '200' ? (
                <div className="_search_result_layout">
                  <div className="_cont">
                    <>
                      <ul className="_item">
                        <li className="_label">접수번호</li>
                        <li className="_cont">{complaintSearchResult.resultData.rcpt_id}</li>
                      </ul>
                      <ul className="_item">
                        <li className="_label">신고유형</li>
                        <li className="_cont">
                          {complaintSearchResult.resultData.rcpt_type !== ''
                            ? complaintSearchResult.resultData.rcpt_type
                            : '챗봇으로 접수한 민원만 확인 가능합니다.'}
                        </li>
                      </ul>
                      <ul className="_item">
                        <li className="_label">접수위치</li>
                        <li className="_cont">{complaintSearchResult.resultData.rcpt_addr}</li>
                      </ul>
                      <ul className="_item">
                        <li className="_label">접수일시</li>
                        <li className="_cont">{complaintSearchResult.resultData.rcpt_dt.slice(0, 16)}</li>
                      </ul>
                      <ul className="_item">
                        <li className="_label">처리상태</li>
                        <li className="_cont">{complaintSearchResult.resultData.prcs_st}</li>
                      </ul>
                      {complaintSearchResult.resultData.prcs_dept_nm !== '' && complaintSearchResult.resultData.prcs_dept !== '' ? (
                        <ul className="_item">
                          <li className="_label">담당부서</li>
                          <li className="_cont">
                            {complaintSearchResult.resultData.prcs_dept_nm} {complaintSearchResult.resultData.prcs_dept}
                          </li>
                        </ul>
                      ) : null}
                    </>
                  </div>
                </div>
              ) : (
                <div className="_search_result_layout">
                  <div className="_cont">
                    <>
                      <ul className="_item">
                        <li className="_label">조회실패</li>
                        <li className="_cont">접수번호 및 연락처를 다시 확인해 주세요</li>
                      </ul>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintSearch;
